import proj4 from "proj4";

import { Raster, RasterStyle } from "@nens/lizard/api-v4";
import { combineUrlAndParams, convertMsToTimestampISO } from "@nens/shared-utils";

function lngLatToMercator(x: number, y: number) {
  return proj4("WGS84", "EPSG:3857", [x, y]);
}

export function makeWmsRequest(
  url: string,
  params: {
    raster: Raster;
    width: number;
    height: number;
    time: Date;
    bbox: number[][];
    rasterStyle?: RasterStyle | null;
  }
) {
  const { raster, width, height, time, bbox, rasterStyle } = params;

  const { wms_info, options } = raster;

  let styles = rasterStyle?.toString() ?? options["styles"] ?? "";
  let layer = wms_info.layer;

  if (styles && typeof styles !== "string") {
    if (styles["0"]["0"] === "radar-5min") {
      layer = "radar:5min";
    }
    styles = styles["0"]["0"];
  }

  const southwest = lngLatToMercator(bbox[3][0], bbox[3][1]);
  const northeast = lngLatToMercator(bbox[1][0], bbox[1][1]);

  const wmsParams: Record<string, string | number | boolean> = {
    SERVICE: "WMS",
    REQUEST: "GetMap",
    VERSION: "1.1.1",
    SRS: "EPSG:3857",
    LAYERS: layer,
    STYLES: styles,
    FORMAT: "image/png",
    TRANSPARENT: false,
    HEIGHT: height,
    WIDTH: width,
    TIME: convertMsToTimestampISO(time.getTime()),
    BBOX: `${southwest[0]},${southwest[1]},${northeast[0]},${northeast[1]}`,
  };

  return combineUrlAndParams(url, wmsParams);
}
